import React from 'react';
import { Popconfirm } from '../../../../components/popovers';

import {
  DropdownItem,
  DropdownList,
  DropdownContent,
} from '../../../../components/ui-helpers/dropdown';
import { SimpleButton } from './styled-components';


const Overlay = (
  _id,
  reInviteUser,
  onDeleteUser,
  onRestoreUser,
  onChangeUserRole,
  onCancelInvitation,
  authorizedUserActions,
) => (
  <DropdownContent>
    <DropdownList>
      {authorizedUserActions.canPromoteToAdmin &&
        <DropdownItem>
          <SimpleButton
            onClick={() => onChangeUserRole(_id)}
          >
            Promote to Admin
          </SimpleButton>
        </DropdownItem>
      }
      {authorizedUserActions.canArchive &&
        <DropdownItem>
          <Popconfirm
            title="Are you sure delete this user?"
            onConfirm={() => onDeleteUser(_id)}
          >
            <SimpleButton data-popconfirm-stay-open > Archive</SimpleButton>
          </Popconfirm>
        </DropdownItem>
      }
      {authorizedUserActions.canReInvite &&
        <DropdownItem>
          <SimpleButton
            onClick={() => reInviteUser(_id)}
          >
            Resend Invitation
          </SimpleButton>
        </DropdownItem>
      }
      {authorizedUserActions.canCancelInvite &&
        <DropdownItem>
          <Popconfirm
            title="Are you sure cancel invitation?"
            onConfirm={() => onCancelInvitation(_id)}
          >
            <SimpleButton data-popconfirm-stay-open>Cancel Invitation</SimpleButton>
          </Popconfirm>
        </DropdownItem>
      }
      {authorizedUserActions.canRestore &&
      <DropdownItem>
        <Popconfirm
          title="Are you sure restore this user?"
          onConfirm={() => onRestoreUser(_id)}
        >
          <SimpleButton data-popconfirm-stay-open>Restore</SimpleButton>
        </Popconfirm>
      </DropdownItem>
      }
    </DropdownList>
  </DropdownContent>
);

export default Overlay;



// WEBPACK FOOTER //
// ./src/modals/manage-users-modal/list-users/user-list-item/dropdown-overlay.js